import React from 'react'
import Header from './Component/Header'
import Footer from './Component/Footer'
import ElementorInit from './Component/ElementorInit'
import FloatingContact from './Component/FloatingContact'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import LegacyTsrRedirect from './Component/LegacyTsrRedirect'
import Seo from './seo/Seo'
import StructuredData from './seo/StructuredData'
import { getSeoForPath } from './seo/seoConfig'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import WeddingEvents from './pages/WeddingEvents'
import CorporateEvents from './pages/CorporateEvents'
import SocialEvents from './pages/SocialEvents'
import CanteenPage from './pages/CanteenPage'
import Menu from './pages/Menu'
import Venues from './pages/Venues'
import ImageGallery from './pages/ImageGallery'
import VideoGallery from './pages/VideoGallery'
import Contact from './pages/Contact'
import EventsDecoration from './pages/EventsDecoration'
import DeliveryServices from './pages/DeliveryServices'
import PrivateEvents from './pages/PrivateEvents'
import Brands from './pages/Brands'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Timeline from './pages/Timeline'
import WeddingCateringMenu from './pages/WeddingCateringMenu'
import CorporateCateringMenu from './pages/CorporateCateringMenu'
import CorporateEventsDecorationMenu from './pages/CorporateEventsDecorationMenu'
import Catering from './pages/Catering'
import KidsSpecialParties from './pages/KidsSpecialParties'
import AlpphaFoods from './pages/AlpphaFoods'
import Menu2 from './pages/Menu2'
import FamilyGatheringsMenu from './pages/FamilyGatheringsMenu'
import KidsPartiesMenu from './pages/KidsPartiesMenu'
import KidsSpecialEventsDecorationMenu from './pages/KidsSpecialEventsDecorationMenu'
import SocialEventsEventsDecoration from './pages/SocialEventsEventsDecoration'
import WeddingEventsDecoration from './pages/WeddingEventsDecoration'
import CorporateEventsDecorationPage from './pages/CorporateEventsDecorationPage'
import FamilyGatheringsEventsDecoration from './pages/FamilyGatheringsEventsDecoration'
import KidsSpecialPartiesEventsDecoration from './pages/KidsSpecialPartiesEventsDecoration'
import BuffetCateringWithService from './pages/BuffetCateringWithService'
import BuffetCateringCorporate from './pages/BuffetCateringCorporate'
import BuffetCateringFamily from './pages/BuffetCateringFamily'
import BuffetCateringKids from './pages/BuffetCateringKids'
import CateringInPune from './pages/CateringInPune'
import TsrOrderRoutes from './features/tsr-order/TsrOrderRoutes'
import TsrAdminRoutes from './features/tsr-order/TsrAdminRoutes'

const isSubpathDeploy = Boolean((process.env.PUBLIC_URL || '').replace(/\/$/, '')); // local dev: false; production /tsr: true

const isTsrOrderAppPath = (pathname) => (
  pathname === '/tsr-order'
  || pathname.startsWith('/tsr-order/')
  || pathname === '/tsr-admin'
  || pathname.startsWith('/tsr-admin/')
);

function RouteSeo() {
  const { pathname } = useLocation()
  const seo = getSeoForPath(pathname)

  return (
    <>
      <Seo {...seo} canonicalPath={pathname} robots={seo.robots} />
      <StructuredData includeContactFaq={pathname === '/contact'} />
    </>
  )
}

function App() {
  const { pathname } = useLocation()
  const hideMarketingChrome = isTsrOrderAppPath(pathname)

  return (
    <>
      <RouteSeo />
      {!hideMarketingChrome ? <ElementorInit /> : null}
      {!hideMarketingChrome ? <FloatingContact /> : null}
      {!hideMarketingChrome ? <Header /> : null}
      <Routes>
        <Route path="/tsr-order/*" element={<TsrOrderRoutes />} />
        <Route path="/tsr-admin/*" element={<TsrAdminRoutes />} />
        {!isSubpathDeploy && (
          <>
            <Route path="/tsr" element={<Navigate to="/" replace />} />
            <Route path="/tsr/*" element={<LegacyTsrRedirect />} />
          </>
        )}
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/services' element={<Services />} />
        <Route path='/wedding-events' element={<WeddingEvents />} />
        <Route path='/corporate-events' element={<CorporateEvents />} />
        <Route path='/social-events' element={<SocialEvents />} />
        <Route path='/canteen' element={<CanteenPage />} />
        <Route path='/canteen-page' element={<Navigate to="/canteen" replace />} />
        <Route path='/canteen-page/*' element={<Navigate to="/canteen" replace />} />
        <Route path='/menu' element={<Menu />} />
        <Route path='/venues' element={<Venues />} />
        <Route path='/image-gallery' element={<ImageGallery />} />
        <Route path='/video-gallery' element={<VideoGallery />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/buffet-catering' element={<BuffetCateringWithService />} />
        <Route path='/buffet-catering-corporate' element={<BuffetCateringCorporate />} />
        <Route path='/buffet-catering-family' element={<BuffetCateringFamily />} />
        <Route path='/buffet-catering-kids' element={<BuffetCateringKids />} />
        <Route path='/events-decoration' element={<EventsDecoration />} />
        <Route path='/wedding-events-decoration' element={<WeddingEventsDecoration />} />
        <Route path='/corporate-events-decoration' element={<CorporateEventsDecorationPage />} />
        <Route path='/social-events-decoration' element={<SocialEventsEventsDecoration />} />
        <Route path='/family-gatherings-decoration' element={<FamilyGatheringsEventsDecoration />} />
        <Route path='/kids-parties-decoration' element={<KidsSpecialPartiesEventsDecoration />} />
        <Route path='/delivery-services' element={<DeliveryServices />} />
        <Route path='/private-events' element={<PrivateEvents />} />
        <Route path='/brands' element={<Brands />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/timeline' element={<Timeline />} />
        <Route path='/wedding-catering-menu' element={<WeddingCateringMenu />} />
        <Route path='/corporate-catering-menu' element={<CorporateCateringMenu />} />
        <Route path='/corporate-events-decoration-menu' element={<CorporateEventsDecorationMenu />} />
        <Route path='/catering' element={<Catering />} />
        <Route path='/catering-in-pune' element={<CateringInPune />} />
        <Route path='/kids-special-parties' element={<KidsSpecialParties />} />
        <Route path='/maanas-banquets' element={<Navigate to="/venues" replace />} />
        <Route path='/alppha-foods' element={<AlpphaFoods />} />
        <Route path='/menu-2' element={<Menu2 />} />
        <Route path='/family-gatherings-menu' element={<FamilyGatheringsMenu />} />
        <Route path='/kids-parties-menu' element={<KidsPartiesMenu />} />
        <Route path='/kids-special-events-decoration-menu' element={<KidsSpecialEventsDecorationMenu />} />
        <Route path='/social-events-events-decoration' element={<SocialEventsEventsDecoration />} />
      </Routes>
      {!hideMarketingChrome ? <Footer /> : null}
    </>
  )
}

export default App
